export default __webpack_public_path__ + "static/media/rentacar_img_Seat_03.8d6a127f.png";